import APIService from "../../services/apiService";
import ObjectToQueryParams from "../../services/ObjectToQueryParams";
import handleCallback from "../../helper/APICallback";
import AuthService from "../../services/authService";
import { path } from "../paths";
const API = AuthService.getRemoteURL();

export function fetchTableDetails(params) {
  const query = ObjectToQueryParams(params?.params);
  const URL = `${API}${path.tableQR.table.details}${query}`;
  return new Promise((resolve, reject) => {
    APIService.request(
      {
        url: URL,
        method: "GET",
      },
      handleCallback(resolve, reject)
    );
  });
}
